/* Collection filter bar. Extracted from sections/collection-filters-section.liquid so it
   ships cached instead of ~11KB inline. Root lookup uses the .cf class rather than the
   per-section id, so no Liquid is required. */
(function () {
    var root = document.querySelector('.cf');
    if (!root || root.dataset.cfInit) return;
    root.dataset.cfInit = '1';

    var form = root.querySelector('.cf__form');
    var collectionUrl = root.dataset.collectionUrl || window.location.pathname;
    /* Set by the section — the search page renders a different grid id and section. */
    var GRID_ID = root.dataset.gridId || 'CollectionProductGrid';
    var GRID_SECTION = root.dataset.gridSection || 'collection-product-grid';
    var pills = root.querySelector('[data-cf-pills]');
    var mcount = root.querySelector('[data-cf-mcount]');

    function debounce(fn, wait) {
      var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
    }

    /* ---- Build query params from current form state ---- */
    function buildParams() {
      var params = new URLSearchParams();
      /* Hidden fields first — on the search page these carry q/type, and dropping them
         would turn the first filter click into an empty search. */
      form.querySelectorAll('input[type="hidden"]').forEach(function (h) {
        if (h.name && h.value !== '') params.append(h.name, h.value);
      });
      // checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });
      // price (only if a value is present)
      form.querySelectorAll('input[data-cf-num]').forEach(function (inp) {
        if (inp.value !== '' && inp.name) params.append(inp.name, inp.value);
      });
      // sort
      var sort = form.querySelector('[data-cf-sort]');
      if (sort && sort.value) params.append('sort_by', sort.value);
      return params;
    }

    /* ---- AJAX apply: swap the product grid, push URL ---- */
    var inFlight = 0;
    function apply() {
      var params = buildParams();
      // URLSearchParams encodes spaces as "+"; Shopify option params (e.g.
      // "filter.v.option.metal color") need %20, so normalise.
      var qs = params.toString().replace(/\+/g, '%20');
      var newUrl = qs ? collectionUrl + '?' + qs : collectionUrl;
      var fetchUrl = collectionUrl + '?section_id=' + GRID_SECTION + (qs ? '&' + qs : '');
      var grid = document.getElementById(GRID_ID);
      if (grid) grid.style.opacity = '0.45';
      var token = ++inFlight;
      fetch(fetchUrl)
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
        .then(function (html) {
          if (token !== inFlight) return; // a newer request superseded this one
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.getElementById(GRID_ID);
          var cur = document.getElementById(GRID_ID);
          if (!next || !cur) { window.location.assign(newUrl); return; }
          cur.innerHTML = next.innerHTML;
          hydrateShapeIcons(cur);
          cur.style.opacity = '';
          if (window.Alpine && Alpine.initTree) { try { Alpine.initTree(cur); } catch (e) {} }
          window.dispatchEvent(new CustomEvent('wishlist:refresh'));
          history.pushState({ cf: 1 }, '', newUrl);
        })
        .catch(function () {
          // fetch blocked (e.g. preview sandbox) — fall back to a normal navigation,
          // which the server renders with the same filters applied.
          window.location.assign(newUrl);
        });
      renderPills();
      updateCount();
    }
    var applyDebounced = debounce(apply, 350);

    /* ---- Active-filter pills (built from current state) ---- */
    function makePill(text, onRemove) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cf__pill';
      b.innerHTML = '<span></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>';
      b.querySelector('span').textContent = text;
      b.addEventListener('click', onRemove);
      return b;
    }
    function renderPills() {
      if (!pills) return;
      pills.innerHTML = '';
      var any = false;
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        any = true;
        var g = cb.getAttribute('data-group') || '';
        var l = cb.getAttribute('data-label') || cb.value;
        pills.appendChild(makePill(g + ': ' + l, function () { cb.checked = false; syncSwatchState(); apply(); }));
      });
      var nums = form.querySelectorAll('input[data-cf-num]');
      var priceActive = false;
      nums.forEach(function (n) { if (n.value !== '') priceActive = true; });
      if (priceActive) {
        any = true;
        var mn = form.querySelector('input[data-cf-num="min"]');
        var mx = form.querySelector('input[data-cf-num="max"]');
        var txt = 'Price: $' + (mn && mn.value !== '' ? mn.value : '0') + ' – $' + (mx && mx.value !== '' ? mx.value : (mx ? mx.placeholder : ''));
        pills.appendChild(makePill(txt, function () { clearPrice(); apply(); }));
      }
      if (any) {
        var clr = document.createElement('button');
        clr.type = 'button'; clr.className = 'cf__clear'; clr.textContent = 'Clear all';
        clr.addEventListener('click', clearAll);
        pills.appendChild(clr);
      }
    }

    function updateCount() {
      if (!mcount) return;
      var n = form.querySelectorAll('input[type="checkbox"]:checked').length;
      form.querySelectorAll('input[data-cf-num]').forEach(function (x) { if (x.value !== '') n++; });
      mcount.textContent = n > 0 ? '(' + n + ')' : '';
    }

    function clearPrice() {
      form.querySelectorAll('input[data-cf-num]').forEach(function (n) { n.value = ''; });
      root.querySelectorAll('[data-cf-price]').forEach(function (p) { resetPriceUI(p); });
    }
    function clearAll() {
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) { cb.checked = false; });
      clearPrice();
      syncSwatchState();
      apply();
    }

    /* keep any per-filter badge counts in sync with the checkboxes (dropdowns) */
    function syncSwatchState() {
      root.querySelectorAll('[data-cf-dd]').forEach(function (dd) {
        var badge = dd.querySelector('.cf__badge');
        var n = dd.querySelectorAll('input[type="checkbox"]:checked').length;
        if (n > 0) {
          if (!badge) {
            badge = document.createElement('span'); badge.className = 'cf__badge';
            var caret = dd.querySelector('.cf__caret');
            dd.querySelector('.cf__trigger').insertBefore(badge, caret);
          }
          badge.textContent = n;
        } else if (badge) { badge.remove(); }
      });
    }

    /* ---- Price slider <-> number sync ---- */
    function resetPriceUI(p) {
      var max = parseFloat(p.getAttribute('data-range-max')) || 0;
      var sMin = p.querySelector('[data-cf-slider="min"]');
      var sMax = p.querySelector('[data-cf-slider="max"]');
      if (sMin) sMin.value = 0;
      if (sMax) sMax.value = max;
      paintFill(p);
    }
    function paintFill(p) {
      var max = parseFloat(p.getAttribute('data-range-max')) || 1;
      var sMin = p.querySelector('[data-cf-slider="min"]');
      var sMax = p.querySelector('[data-cf-slider="max"]');
      var fill = p.querySelector('[data-cf-fill]');
      if (!sMin || !sMax || !fill) return;
      var lo = Math.min(+sMin.value, +sMax.value), hi = Math.max(+sMin.value, +sMax.value);
      fill.style.left = (lo / max * 100) + '%';
      fill.style.width = ((hi - lo) / max * 100) + '%';
    }
    root.querySelectorAll('[data-cf-price]').forEach(function (p) {
      var max = parseFloat(p.getAttribute('data-range-max')) || 0;
      var sMin = p.querySelector('[data-cf-slider="min"]');
      var sMax = p.querySelector('[data-cf-slider="max"]');
      var nMin = p.querySelector('input[data-cf-num="min"]');
      var nMax = p.querySelector('input[data-cf-num="max"]');
      paintFill(p);
      function fromSlider() {
        var lo = Math.min(+sMin.value, +sMax.value), hi = Math.max(+sMin.value, +sMax.value);
        nMin.value = lo > 0 ? lo : '';
        nMax.value = hi < max ? hi : '';
        paintFill(p);
      }
      function fromNumber() {
        var lo = nMin.value === '' ? 0 : Math.max(0, Math.min(+nMin.value, max));
        var hi = nMax.value === '' ? max : Math.max(0, Math.min(+nMax.value, max));
        sMin.value = lo; sMax.value = hi; paintFill(p);
      }
      if (sMin) sMin.addEventListener('input', function () { fromSlider(); });
      if (sMax) sMax.addEventListener('input', function () { fromSlider(); });
      if (sMin) sMin.addEventListener('change', applyDebounced);
      if (sMax) sMax.addEventListener('change', applyDebounced);
      if (nMin) nMin.addEventListener('change', function () { fromNumber(); applyDebounced(); });
      if (nMax) nMax.addEventListener('change', function () { fromNumber(); applyDebounced(); });
    });

    /* ---- Wiring: checkboxes + sort ---- */
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type="checkbox"]')) { syncSwatchState(); applyDebounced(); }
      else if (t.matches('[data-cf-sort]')) { apply(); }
    });
    // prevent native GET submit when JS is active
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });

    /* ---- Swatch "+N" expand ---- */
    root.querySelectorAll('[data-cf-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.cf__swatches');
        wrap.classList.add('is-expanded');
        btn.remove();
      });
    });

    /* ---- Dropdown: one open at a time + click-away (desktop) ---- */
    document.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 767px)').matches) return; // accordions on mobile
      root.querySelectorAll('[data-cf-dd][open]').forEach(function (dd) {
        if (!dd.contains(e.target)) dd.removeAttribute('open');
      });
    });
    root.querySelectorAll('[data-cf-dd] .cf__trigger').forEach(function (sm) {
      sm.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 767px)').matches) return;
        var self = sm.parentElement;
        root.querySelectorAll('[data-cf-dd][open]').forEach(function (dd) { if (dd !== self) dd.removeAttribute('open'); });
      });
    });

    /* ---- Mobile drawer ---- */
    function openDrawer() { root.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { root.classList.remove('is-open'); document.body.style.overflow = ''; }
    root.querySelectorAll('[data-cf-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    root.querySelectorAll('[data-cf-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    var scrim = root.querySelector('[data-cf-scrim]');
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (root.classList.contains('is-open')) closeDrawer();
        root.querySelectorAll('[data-cf-dd][open]').forEach(function (dd) { dd.removeAttribute('open'); });
      }
    });

    /* ---- Back/forward: reload so the grid matches the restored URL ---- */
    window.addEventListener('popstate', function () { window.location.reload(); });

    /* ---- Shape icons ----
       The icon set is a JS map (window.NYCDD_SHAPE_ICONS, from diamond-shape-icons.liquid)
       so it can only be filled in on the client. The label stays in the markup as the
       no-JS fallback, and this re-runs after an AJAX apply because the filter bar only
       re-renders the grid — but a filtered request can change which values are listed. */
    function hydrateShapeIcons(scope) {
      var icons = window.NYCDD_SHAPE_ICONS || {};
      (scope || root).querySelectorAll('[data-shape-icon]').forEach(function (el) {
        if (el.dataset.cfIconDone) return;
        var svg = icons[el.getAttribute('data-shape-icon')];
        if (!svg) return;
        el.innerHTML = svg;
        el.dataset.cfIconDone = '1';
      });
    }

    /* ---- Init from server-rendered state ---- */
    renderPills();
    updateCount();
    hydrateShapeIcons();
  })();
